import React, { Component } from 'react';
import { Header } from '../components/modules/HeaderContent';
import { Footer } from '../components/modules/FooterContent';
import BreadCrumb from './modules/BreadCrumb';
import ReactHtmlParser from 'react-html-parser';
import {Accordion, AccordionHeader, AccordionTitle, AccordionSubTitle, AccordionDetail, AccordionItem} from '@vds/accordions';
// import AccordionOld from './modules/Accordion';
import SignInForm from './modules/EqReturnNonSignIn'
import EQReturnModalDialog from './modules/EQReturnOrderPopup';
import EquipmentDetails from './modules/EquipmentDetails';
import NeedToKnow from './modules/NeedToKnow';
import Rotator from './modules/Rotator';
import { RTCICall } from "./modules/RTCICall";
import { Chat } from "./modules/IncludeChat";
import { SIT_SERVER, MS_LOCATION } from '../constants/constants';
import { ORDER_NUMBER_CONTENT } from '../constants/dialogsContent';
import '../assets/css/eqreturns.css';
import { getOS, isNullOrUndefined, RemoveHeaderHiddenClass } from './modules/CommonFunctions';
import ErrorBoundary from './modules/ErrorHandler';
import { SiteCatalyst } from '../components/modules/SiteCatalyst';
import AlertBanner from './modules/AlertBanner';
import NeedMoreSupport from './modules/NeedMoreSupport';

export default class EquipmentReturn extends React.Component {
	constructor(props) {
		super(props);
		this.isMobile = (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) ? true : false;
		this.dialogRef = React.createRef();
		this.ischkValidUser = false;
		if(window.userinfo !== null) {this.ischkValidUser = true;}
		if(window.oneAppFlag == true && window.oneAppFlag != null){
			if(this.ischkValidUser){
				this.state = {
					validUser: true,
					/*For running in local ***/
					// validUser: true,
					signInStaticData: {},
					signInDynamicData: {},
					nCogData: {},			
					NEED_TO_KNOW_CONTENT:  JSON.parse(window.erStaticData).rtelist[0].richText 				
				}
			} else {
				this.state = {
					validUser: false,
					/*For running in local */
					// validUser: true,
					signInStaticData: {},
					signInDynamicData: {},
					nCogData: {},			
					NEED_TO_KNOW_CONTENT: (document.cookie.indexOf('userinfo') > -1) ? JSON.parse(window.erStaticData).rtelist[0].richText : ''
					
				} 
			 }
		}
		else{
		this.state = {
			validUser: (document.cookie.indexOf('userinfo') > -1) ? true : false,
			/*For running in local */
			// validUser: true,
			signInStaticData: {},
			signInDynamicData: {},
			nCogData: {},			
			NEED_TO_KNOW_CONTENT: (document.cookie.indexOf('userinfo') > -1) ? JSON.parse(window.erStaticData).rtelist[0].richText : ''
			
		}
	  }		
		this.isDropOffPage = false;
		this.MTNRef = React.createRef();
		this.ZipCodeRef = React.createRef();
		this.SignInRef = React.createRef();
		this.successCallBack = this.ufdSuccessCallback.bind(this);
		this.failureCallBack = this.ufdFailureCallBack.bind(this);
		this.signInStaticData = {};
		this.signInDynamicData = {};
		this.printLabelContent = "";
		this.MON = "";
		this.ZIP = "";
		this.isValidUser = document.cookie.indexOf('userinfo') > -1 ? true : false;		
		this.EQhandleKeyAction = this.EQhandleKeyAction.bind(this);
	}

	componentDidMount() {
		/* For loading page in local */
		// this.setState({
		// 	validUser: true,
		// 	signInStaticData: this.props.StaticData,
		// 	signInDynamicData: this.props.DynamicData,
		// 	nCogData: this.props.NcogData
		//  })

		let operatingSystem = getOS();
		let intent = "";
		let args = {
			equipment_name: "Equipment returns",
			intentCategory: "NBA_DISPLAY",
			activityCategory: "NBA_DISPLAY",
			intent: intent,
			app_n_channel: "NBA-ESUPPORT",
			os: operatingSystem,
			pegaSessionID: "",
			userid: (this.isValidUser) ? window.userinfo.userId : "",
			visionID: (this.isValidUser) ? window.userinfo.visionId : "",
			accountID: (this.isValidUser) ? window.userinfo.visionAcctId : ""
		};
		RTCICall(args);

		// For directly rendering frk/dropoff page without manual signin
		if (window.userinfo !== null && Object.keys(this.state.signInStaticData).length === 0 && Object.keys(this.state.signInDynamicData).length === 0) {
			this.signInStaticData = Object.assign(this.signInStaticData, this.convertStringToObject(this.props.StaticData));
			this.signInDynamicData = Object.assign(this.signInDynamicData, this.convertStringToObject(this.props.DynamicData));
			if (Object.keys(this.signInStaticData).length > 0 && !isNullOrUndefined(this.signInDynamicData.orderDetails) && Object.keys(this.signInDynamicData.orderDetails).length > 0) {
				if (this.signInDynamicData.orderDetails.ReturnType !== "FRK") {
					this.isDropOffPage = true;
				}
			}
			if (document.querySelector('.show_spinner') !== null) {
				document.querySelector('.show_spinner').classList.remove('show_spinner');
			}
			this.setState({
				validUser: true,
				signInStaticData: this.signInStaticData,
				signInDynamicData: this.signInDynamicData,
				nCogData: this.props.NcogData
				
			})
		}
		//window.constructScData('urlPageLoad','');
		Chat();
		RemoveHeaderHiddenClass();
	}

	getISOCNumber() {
		let ISOC = "";
		for (let i = 0; i < this.state.signInDynamicData.equipDetails.length; i++) {
			ISOC = ISOC + this.state.signInDynamicData.equipDetails[i].ISOCNumber + ":1"
			if (i < this.state.signInDynamicData.equipDetails.length - 1) {
				ISOC = ISOC + "|";
			}
		}
		return ISOC;
	}

	getStorelocatorUrl() {
		return "https://www.verizon.com/home/storelocator/";
	}

	printLabel() {
		let ufdEnv = '';
		let AppDomain = null;
		if (document.location.href.indexOf('www98') != -1) {
			ufdEnv = window.UFD.Environments.STG;
			AppDomain = 'www98.verizon.com';
		}
		else if (document.location.href.indexOf('sit') != -1) {
			AppDomain = 'wwwawssit.ebiz.verizon.com';
			ufdEnv = window.UFD.Environments.SIT;
		}
		else if (document.location.href.indexOf('sitaws') != -1) {
			AppDomain = 'wwwawsuat.ebiz.verizon.com';
			ufdEnv = window.UFD.Environments.AWSUAT;
		}
		else if (document.location.href.indexOf('awsuat') != -1) {
			AppDomain = 'wwwawsuat.ebiz.verizon.com';
			ufdEnv = window.UFD.Environments.AWSUAT;
		}
		else if (document.location.href.indexOf('www') != -1) {
			ufdEnv = window.UFD.Environments.PROD;
			AppDomain = 'www.verizon.com';
		}
		let dcktId = "";
		let vcktId = "";
		let btn = "";
		let visionacctid = "";
		let visioncustid = "";
		let ordTyp = "";
		dcktId = this.state.signInDynamicData.dataCircuitID;
		vcktId = "";
		btn = "";
		visionacctid = "null";
		visioncustid = "null";
		ordTyp = this.state.signInDynamicData.orderDetails.OrderType;
		let encVisCustId = this.state.nCogData.encryptedVisionCustId;
		let encVisAcctId = this.state.nCogData.encryptedVisionAccId;
		let encmon = this.state.nCogData.encryptedMon;
		let encdcktId = this.state.nCogData.encryptedDataCktID;
		let pcan = "";
		let mon = this.MON;
		let zip = this.ZIP;
		let frkCnt = this.state.signInDynamicData.orderDetails.FRKCount;
		let frkReOrdElgble = this.state.signInDynamicData.orderDetails.FRKReorderEligible;
		let custAdd1 = this.state.signInDynamicData.orderDetails.CustAddress1;
		let custAdd2 = this.state.signInDynamicData.orderDetails.CustAddress2;
		let isoc = this.getISOCNumber();
		let custState = this.state.signInDynamicData.orderDetails.CustState;
		let custCity = this.state.signInDynamicData.orderDetails.CustCity;
		let custZip = this.state.signInDynamicData.orderDetails.CustZip;
		let UFDPlatform = (this.isMobile) ? "Mobile" : "Web";
		let QS = {};
		QS['ATG_PCAN'] = pcan;
		QS['ATG_BTN'] = btn;
		QS['ATG_VISION_CUSTOMER_ID'] = encVisCustId;
		QS['ATG_VISION_ACCOUNT_ID'] = encVisAcctId;
		QS['ATG_CIRCUIT_ID'] = encdcktId;
		QS['ATG_MASTER_ORDER_NUM'] = encmon;
		QS['ATG_ZIP'] = zip;
		QS['ATG_ORIGIN'] = 'ATG';
		QS['ATG_ISOC'] = isoc;
		QS['ATG_custaddrline1'] = custAdd1;
		QS['ATG_custaddrline2'] = custAdd2;
		QS['ATG_custstate'] = custState;
		QS['ATG_custcity'] = custCity;
		QS['ATG_custzip'] = custZip;
		QS['ATG_FRKReorderEligible'] = frkReOrdElgble;
		QS['ATG_frkcount'] = frkCnt;
		QS['ATG_ORDERTYPE'] = ordTyp;

		QS['ATG_OPERATION'] = "PRINTLABEL";


		let equipmentxml = "";

		for (let i = 0; i < this.state.signInDynamicData.equipDetails.length; i++) {
			if ((this.state.signInDynamicData.equipDetails[i].Make !== null && this.state.signInDynamicData.equipDetails[i].Make !== '') && (this.state.signInDynamicData.equipDetails[i].Model !== null && this.state.signInDynamicData.equipDetails[i].Model !== '')) {
				equipmentxml = equipmentxml + "<CPE_DETAIL><MAKE>" + this.state.signInDynamicData.equipDetails[i].Make + "</MAKE><MODEL>" + this.state.signInDynamicData.equipDetails[i].Model + "</MODEL><QTY>1</QTY></CPE_DETAIL>";
			}
		}
		QS['ATG_EQUIPMENTRETURNS'] = '<EQUIPMENT_DETAIL>' + equipmentxml + '</EQUIPMENT_DETAIL>';
		let contactOptionsFlow = new window.UFDInstance(ufdEnv, "TroubleShooting Flows", "IHA", "EquipmentReturns", UFDPlatform, undefined, undefined, QS);
		contactOptionsFlow.addSuccessEventHandler(this.successCallBack);
		contactOptionsFlow.addErrorEventHandler(this.failureCallBack);
		contactOptionsFlow.Start();
		document.querySelector('.hide_spinner').classList.add('show_spinner');
	}

	ufdSuccessCallback(output, template, json) {
		this.printLabelContent = output;
		this.openDialog(null);
	}
	ufdFailureCallBack(output, template, json) {
		this.printLabelContent = output;
		this.openDialog(null);
	}

	convertStringToObject(data) {
		if (!isNullOrUndefined(data) && data !== "" && typeof (data) === "string") {
			return JSON.parse(data);
		} else if (isNullOrUndefined(data) || data === "") {
			return {};
		} else return data;
	}

	validateForm() {
		document.querySelectorAll ("#validErr")[0].innerText = "";
		document.querySelector('#error-ordernumber').innerText ="";
		document.querySelector('#error-zipcode').innerText="";
		let lengthMessage = "This field length is invalid. It should be between 8 and 13 characters long";
		let zipCodeLenthMessage = "This field length is invalid. It should be 5 characters long";
		let defaultMessage = "This field is required";
		let loValidateErrorMessage = "";
		let tabindexvalue ="0";	
		if (this.MTNRef.current.value === "") {
			this.MTNRef.current.parentElement.querySelector('.signin-error').innerText = defaultMessage;
			this.MTNRef.current.parentElement.classList.add('validation_error');
			document.querySelector('#orderNumber').focus();
		}
		if (this.MTNRef.current.value.length < 8 && this.MTNRef.current.value !== "") {
			this.MTNRef.current.parentElement.querySelector('.signin-error').innerText = lengthMessage;
			this.MTNRef.current.parentElement.classList.add('validation_error');
           var errOrderNum = document.querySelectorAll ("#error-ordernumber");
           errOrderNum[0].setAttribute("aria-labelledby", lengthMessage);	
		   errOrderNum[0].setAttribute("tabIndex", "-1"); 	   
		  // document.querySelector('#error-ordernumber').focus();
		  document.querySelector('#orderNumber').focus();
		
		}
		if (this.MTNRef.current.value.length >= 8) {
			this.MTNRef.current.parentElement.querySelector('.signin-error').innerText = "";
			this.MTNRef.current.parentElement.classList.remove('validation_error');

			if (this.ZipCodeRef.current.value === "") {
				this.ZipCodeRef.current.parentElement.querySelector('.signin-error').innerText = defaultMessage;
				this.ZipCodeRef.current.parentElement.classList.add('validation_error');

				setTimeout(() => {			
					try{			  
						var errzipcodeMess = document.querySelectorAll ("#error-zipcode");
					errzipcodeMess[0].setAttribute("aria-labelledby", zipCodeLenthMessage);		
					//errzipcodeMess[0].setAttribute("tabIndex", "0");   
					//document.querySelector('#error-zipcode').focus();
                    document.querySelector('#zipCode').focus();                   
                    console.log("zip - submit focus");
                    var subbtnSetInx = document.querySelectorAll ("#Submit");
                    subbtnSetInx[0].setAttribute("tabIndex", '-1'); 
					}catch(e){}			
				}, 100);
			}
		}

		if (this.ZipCodeRef.current.value === "") {
			this.ZipCodeRef.current.parentElement.querySelector('.signin-error').innerText = defaultMessage;
			this.ZipCodeRef.current.parentElement.classList.add('validation_error');
		}
		
		if (this.ZipCodeRef.current.value.length < 5 && this.ZipCodeRef.current.value !== "") {
			this.ZipCodeRef.current.parentElement.querySelector('.signin-error').innerText = zipCodeLenthMessage;
			this.ZipCodeRef.current.parentElement.classList.add('validation_error');			
		setTimeout(() => {			
			try{			  
				var errzipcodeMess = document.querySelectorAll ("#error-zipcode");
			errzipcodeMess[0].setAttribute("aria-labelledby", zipCodeLenthMessage);		
			//errzipcodeMess[0].setAttribute("tabIndex", "0");   
			//document.querySelector('#error-zipcode').focus();
			}catch(e){}			
		}, 100);
			
		}
		if (this.ZipCodeRef.current.value.length >= 5) {
			this.ZipCodeRef.current.parentElement.querySelector('.signin-error').innerText = "";
			this.ZipCodeRef.current.parentElement.classList.remove('validation_error');
		}
		if (document.querySelectorAll('.validation_error').length === 0) {
			this.MON = this.MTNRef.current.value;
			this.ZIP = this.ZipCodeRef.current.value;
			let url = MS_LOCATION + "/getNcog?zipCd=" + this.ZipCodeRef.current.value;
			let requestJSON = {
				"getVzOrderRequest": {
					"HeaderInfo": {
						"requestHeaderInfo": {
							"applicationName": "VZCOM",
							"applicationId": "VZCOM",
							"ClientMachineName": "null",
							"RepLoginCode": "RNI26BI",
							"AppServerName": "www.verizon.com",
							"AppServerTimeStamp": "05/12/2018 10:08:38 EST",
							"TrackingNumber": "a7h-6eq6J2u4Z1dgfZxCl2_kNa4bPTejTA8gbmt5WTT4JiDFbCEt!914459886!1155237831!1544022518458"
						}
					},
					"maskInd": "N",
					"serviceState": "EAST",
					"MON": this.MTNRef.current.value,
					"SuppressBSGLDOrders": "Y",
					"includePCIInformation": "Y",
					"includeSuppressedProducts": "Y"
				}
			}
			let localInstance = this;
			let staticData = {};
			let dynamicData = {};
			let strResponseData ={};			
			document.querySelector('.hide_spinner').classList.add('show_spinner');
			fetch(url, {
				method: "POST",
				headers: new Headers({
					'content-type': 'application/json'
				}),
				body: JSON.stringify(requestJSON)
			}).then(function (response) {
				return response.json();
			}).then(function (e) {
				strResponseData ={};
				strResponseData = e;
				staticData = localInstance.convertStringToObject(e.staticData);
				dynamicData = localInstance.convertStringToObject(e.dynamicData);
				if (Object.keys(staticData).length > 0 && Object.keys(dynamicData).length > 0 && e.nCogData.zipcodematch.toLowerCase() === "passed") {
					localInstance.SignInRef.current.innerText = "";
					if (dynamicData.orderDetails.ReturnType !== "FRK" && dynamicData.orderDetails.ReturnType !== undefined) {
						localInstance.isDropOffPage = true;
					}
					if (document.querySelector('.show_spinner') !== null) {
						document.querySelector('.show_spinner').classList.remove('show_spinner');
					}
					localInstance.setState({
						validUser: true,
						signInStaticData: staticData,
						signInDynamicData: dynamicData,
						nCogData: e.nCogData
					})
				} else {
					if (document.querySelector('.show_spinner') !== null) {
						document.querySelector('.show_spinner').classList.remove('show_spinner');
					}
					let error = (!isNullOrUndefined(e.nCogData.errormessage)) ? e.nCogData.errormessage : "Server can't be reached at this moment";
					localInstance.SignInRef.current.innerText = error;
					loValidateErrorMessage="";
					loValidateErrorMessage= error;	
									
					if(document.querySelector('#validErr')!= null){
						var preview = document.querySelectorAll ("#validErr");
                         preview[0].setAttribute("aria-labelledby", loValidateErrorMessage); 
						// preview[0].setAttribute("tabIndex", tabindexvalue); 
						// document.querySelector('#validErr').focus();
						 var subbtnSetInx = document.querySelectorAll ("#Submit");
						 subbtnSetInx[0].setAttribute("tabIndex", '-1'); 
						 
					  }
						
				}
			}).catch(function (e) {
                e = strResponseData;
				staticData = localInstance.convertStringToObject(e.staticData);
				dynamicData = localInstance.convertStringToObject(e.dynamicData);

				if (document.querySelector('.show_spinner') !== null) {
					document.querySelector('.show_spinner').classList.remove('show_spinner');
				}
				if((!isNullOrUndefined(dynamicData.desc.toLowerCase() === "notfound"))&& (!isNullOrUndefined(e.nCogData.zipcodematch.toLowerCase() === "passed"))){
					localInstance.SignInRef.current.innerText = "No equipment to be returned";
					loValidateErrorMessage ="";
					loValidateErrorMessage = "No equipment to be returned";;	
				}else{
				localInstance.SignInRef.current.innerText = "Server can't be reached at this moment";
				loValidateErrorMessage ="";
				loValidateErrorMessage = "Server can't be reached at this moment";;	
				}	
				if(document.querySelector('#validErr')!= null){
					var preview = document.querySelectorAll ("#validErr");
                     preview[0].setAttribute("aria-labelledby", loValidateErrorMessage); 
					// preview[0].setAttribute("tabIndex", tabindexvalue); 
					// document.querySelector('#validErr').focus();
					 var subbtnSetInx = document.querySelectorAll ("#Submit");
					 subbtnSetInx[0].setAttribute("tabIndex", '-1'); 
					 
				 
				}
				  
			})
		}
		
	}

	validateOnKeyUp(e) {
		document.querySelectorAll("#validErr")[0].innerHTML = "";	
		document.querySelector('#error-ordernumber').innerText ="";
		document.querySelector('#error-zipcode').innerText="";	
		let lengthMessage = "This field length is invalid. It should be between 8 and 13 characters long";
		let zipCodeLenthMessage = "This field length is invalid. It should be 5 characters long";
		let defaultMessage = "This field is required";
		if (e.target.parentElement.classList.contains('validation_error')) {
			if (e.target.value === "") {
				e.target.parentElement.querySelector('.signin-error').innerText = defaultMessage;
				e.target.parentElement.classList.add('validation_error');
			}
			if (e.target.classList.contains('mtn')) {
				if (e.target.value.length < 8 && e.target.value !== "") {
					e.target.parentElement.querySelector('.signin-error').innerText = lengthMessage;
					e.target.parentElement.classList.add('validation_error');
					var errOrderNumber = document.querySelectorAll ("#error-ordernumber");
					errOrderNumber[0].setAttribute("aria-labelledby", lengthMessage);	
					//errOrderNumber[0].setAttribute("tabIndex", "0");    
					//document.querySelector('#error-ordernumber').focus();
				}
				if (e.target.value.length >= 8) {
					e.target.parentElement.querySelector('.signin-error').innerText = "";
					e.target.parentElement.classList.remove('validation_error');
				}
			}
			if (e.target.classList.contains('zip')) {
				if (e.target.value.length < 5 && e.target.value !== "") {
					e.target.parentElement.querySelector('.signin-error').innerText = zipCodeLenthMessage;
					e.target.parentElement.classList.add('validation_error');
					setTimeout(() => {			
						try{			  
							var errzipcodeMess = document.querySelectorAll ("#error-zipcode");
						errzipcodeMess[0].setAttribute("aria-labelledby", zipCodeLenthMessage);		
						//errzipcodeMess[0].setAttribute("tabIndex", "0");   
						//document.querySelector('#error-zipcode').focus();
						}catch(e){}			
					}, 100);
				}
				if (e.target.value.length >= 5) {
					e.target.parentElement.querySelector('.signin-error').innerText = "";
					e.target.parentElement.classList.remove('validation_error');
				}

				if (e.target.value.length == 0) {
					e.target.parentElement.querySelector('.signin-error').innerText = zipCodeLenthMessage;
					e.target.parentElement.classList.remove('validation_error');
				}
			}
		}
		var preview = document.querySelectorAll ("#validErr");		
        preview[0].setAttribute("tabIndex", "-1"); 
		if (e.target.classList.contains('zip')){
            console.log("zip - submit focus")
			var subbtnSetInx = document.querySelectorAll ("#Submit");
			subbtnSetInx[0].setAttribute("tabIndex", '0');
		}
	}

	closeDialog(e) {
		console.log("closedialog ---1");
		this.dialogRef.current.classList.add('hide_dialog');
		this.dialogRef.current.classList.remove('active', "position_fixed");
		document.getElementsByClassName('page-overlay')[0].classList.add('hide_dialog');
		document.getElementsByClassName('page-overlay')[0].classList.remove('active');

		var preview = document.querySelectorAll ("#aOrderNumber");
       	preview[0].setAttribute("tabIndex", "0"); 
		document.querySelector('#aOrderNumber').focus();
	}

	EQhandleKeyAction(e) {
        console.log("closedialog ---12")
		if((e.target.classList.contains('modal_header') && e.keyCode === 13) || e.keyCode === 27) {
           // this.props.CloseAction();
		   this.closeDialog(e);
        }

        //Focus trap inside modal overlay - keyboard accessibility fix
        
        var selection = document.querySelector('#EquipmentPopupId') !== null;
        if (selection) {
			console.log("closedialog ---13")
            const  focusableElements = 'button, [href], li:not(.hide-content), input, select, textarea, [tabindex]:not([tabindex="-1"])';
            const modal = document.querySelector('#EquipmentPopupId');
        // const tags = [...modal.querySelectorAll('select, input, textarea, button, a, li')].filter(e1 => window.getComputedStyle(e1).getPropertyValue('display') === 'block');
            const focusable = modal.querySelectorAll(focusableElements);
            const firstFocusable = focusable[0];
            const lastFocusable = focusable[focusable.length - 1];

            if (e.ctrlKey || e.altKey) {
                return;
            }

            const keys = {
                9: () => { //9 = TAB
                    if (e.shiftKey && e.target === firstFocusable) {
                        lastFocusable.focus();
                    }

                    if (e.target === lastFocusable) {
                        firstFocusable.focus();
                        e.preventDefault();
                    }
                }
            };

            if (keys[e.keyCode]) {
                keys[e.keyCode]();
            }
        }
       
    }


	updateDialogContent(dialogType) {
		if (dialogType === "storelocations") {
			let orderDetails = this.state.signInDynamicData.orderDetails;
			this.dialogRef.current.querySelector('.modal_content').classList.add("custompopup");
			if (!isNullOrUndefined(orderDetails) && !isNullOrUndefined(orderDetails.Address1) && !isNullOrUndefined(orderDetails.Address2) && !isNullOrUndefined(orderDetails.Address3)) {
				let content = "<h4 class='text-grey-2-active'>View store locations</h4><p>Since you chose to drop off your equipment, here are the three locations closest to your address. Just make sure you return any Verizon-owned within the next 30 days to avoid being billed an unreturned equipment charge.</p>" +
					"<div class='bold'>Your nearest stores:</div><ul class='tiny-block-grid-1 medium-block-grid-3 margin-top-medium store-location'><li><div class='uppercase'>" +
					orderDetails.Address1 + "<br/>" + orderDetails.ContactHours1 + "<br/></div></li><li class='medium-border-vert'><div class='uppercase'>" + orderDetails.Address2 + "<br/>" + orderDetails.ContactHours2 + "<br/></div></li><li><div class='uppercase'>" +
					orderDetails.Address3 + "<br/>" + orderDetails.ContactHours3 + "<br/></div></li></ul><p>View any other store locations: <a class='bold' style='color: #000' href='https://www.verizon.com/home/storelocator' target='_blank' data-track='store locator'>www.verizon.com/home/storelocator</a></p></div>";
				return content;
			} else {
				return "<p>No nearest store location details available.<p>";
			}
		}
	}

	changeDateFormat(Dateval) {
		if (Dateval === null || Dateval === undefined) {
			return " ";
		}
		let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "July", "Aug", "Sep", "Oct", "Nov", "Dec"];
		let date = Dateval.split("/")[0];
		return months[parseInt(Dateval.slice('/')[1]) - 1] + " " + date;
	}

	openDialog(e) {
		if (document.querySelector('.show_spinner') !== null) {
			document.querySelector('.show_spinner').classList.remove('show_spinner');
		}
		this.dialogRef.current.querySelector('.modal_content').innerHTML = "";
		this.dialogRef.current.querySelector('.modal_content').classList.remove("custompopup");
		let dialogContent = "";
		if (e !== null && e !== undefined) {
			dialogContent = (e.target.innerHTML === "View Store Location" || e.target.innerHTML.indexOf('locations') > -1) ? this.updateDialogContent("storelocations") : (e.target.innerHTML === "Unreturned Equipment Pricing")
				? this.state.NEED_TO_KNOW_CONTENT : (e.target.innerHTML === "What is my order number?") ? ORDER_NUMBER_CONTENT : "";
		} else {
			dialogContent = this.printLabelContent;
		}
		this.dialogRef.current.querySelector('.modal_content').innerHTML = dialogContent;
		this.dialogRef.current.classList.remove('hide_dialog');
		this.dialogRef.current.classList.add('active', "position_fixed");
		document.getElementsByClassName('page-overlay')[0].classList.remove('hide_dialog');
		document.getElementsByClassName('page-overlay')[0].classList.add('active');
		
		
		//this.dialogRef.current.document.querySelectorAll('.modal_x').focus();
		
		setTimeout(() => {
			this.dialogRef.current.querySelector('.modal_x').focus();
		
		}, 300);
      

	}

	render() {
		let DynamicPageData = {};
		//let SignInErrorMessage = localStorage.getItem('ValidateErrorMessage');
		document.body.classList.add('erpage');
		if (this.state.validUser && Object.keys(this.state.signInStaticData).length <= 0 && Object.keys(this.state.signInDynamicData).length <= 0) { return null }
		if (!isNullOrUndefined(this.state.signInDynamicData) && !isNullOrUndefined(this.state.signInDynamicData.desc) && this.state.signInDynamicData.desc.toLowerCase() === "notfound" && this.state.signInStaticData.ntklist.length > 0) {
			return (
				<React.Fragment>
					<ErrorBoundary>
						<Header />
					</ErrorBoundary>
					<main role="main" className="main equipment eq-main padding-top-small tiny-wide">
					<ErrorBoundary>
							<BreadCrumb Content1="Support" Content2="Billing & Account" Content3="Equipment Return" />
						</ErrorBoundary>
						<ErrorBoundary>
							<div className="row">
								<AlertBanner
									AlertBannerData={this.props.AlertBanner}
									isBreadCrumb={true}
								/>
							</div>
						</ErrorBoundary>
						<ErrorBoundary>
							<EquipmentDetails SignInStaticData={this.state.signInStaticData} DynamicData={{}} DialogOpen={this.openDialog.bind(this)} ChangeDateFormat={this.changeDateFormat.bind(this)} ClickHandler={this.printLabel.bind(this)} />
						</ErrorBoundary>
						<div className="tiny-padding-vert-tiny medium-padding-vert-small m_status-buttons border-bottom"></div>
						{/* Rotator Title */}
						{!isNullOrUndefined(DynamicPageData) && Object.keys(DynamicPageData).length > 0 &&
							<div className="row margin-vert-zero medium-vert-middle">
								<div className="column padding-vert-zero medium-p-80">
									<h1 className="h3 tiny-padding-left-medium large-padding-left-zero red_font" id="returnEquip">
										Return your equipment in four easy steps
									</h1>
								</div>
							</div>
						}
						{!isNullOrUndefined(DynamicPageData) && Object.keys(DynamicPageData).length > 0 &&
							<ErrorBoundary>
								<Rotator type="equipmentreturn" Data={this.state.signInStaticData.carousellist[0].equipment}></Rotator>
							</ErrorBoundary>
						}
						<ErrorBoundary>
							<NeedToKnow EQReturnData={this.state.signInStaticData} Open={this.openDialog.bind(this)} ></NeedToKnow>
						</ErrorBoundary>
					</main>
					<ErrorBoundary>
						<Footer />
					</ErrorBoundary>
					<ErrorBoundary>
						<EQReturnModalDialog CloseCallBack={this.closeDialog.bind(this)} DialogRef={this.dialogRef} EQhandleKeyMethod={this.EQhandleKeyAction.bind(this)}>
						</EQReturnModalDialog>
					</ErrorBoundary>
					<ErrorBoundary>
						<SiteCatalyst PageDetails={this.state.signInStaticData.pagedetails} />
					</ErrorBoundary>
				</React.Fragment>
			)
		}

		if (!this.state.validUser && !this.isDropOffPage) {
			return (
				<React.Fragment>
					<ErrorBoundary>
						<Header />
					</ErrorBoundary>
					<main role="main" className="main equipment eq-main padding-top-small tiny-wide">
						<ErrorBoundary>
							<BreadCrumb Content1="Support" Content2="Billing & Account" Content3="Equipment Return" />
						</ErrorBoundary>
						<ErrorBoundary>
							<div className="row">
								<AlertBanner
									AlertBannerData={this.props.AlertBanner}
									isBreadCrumb={true}
								/>
							</div>
						</ErrorBoundary>
						<div className="er_title" >
							<h1 className="h2 title" >{this.props.EquipmentReturnData.titledesc[0].title}</h1>
							<h2 className="h5 sub-title" >{this.props.EquipmentReturnData.titledesc[1].title}</h2>
							<div>
								{ReactHtmlParser(this.props.EquipmentReturnData.titledesc[1].richText2)}
							</div>
						</div>
						<ErrorBoundary>
						<div class="row">
                                <div class="tiny-12">
                                    <div className="accordian-wrap">
                                        <Accordion>
                                            {this.props.EquipmentReturnData.accordions[0].accordionList.map(item => (
                                                item.accordionrte && <AccordionItem>
                                                <AccordionHeader 
                                                triggerType="icon"
                                                >      <AccordionTitle><span className="accordian-title">{item.accordianHeading}</span></AccordionTitle>
                                                </AccordionHeader>
                                                <AccordionDetail>
                                                {ReactHtmlParser(item.accordionrte)}
                                                </AccordionDetail>
                                            </AccordionItem>))}
                                        </Accordion>
                                    </div>
                                </div>
                            </div>
							{/* <AccordionOld HeaderClass="hide_header" Header="" DataSource={this.props.EquipmentReturnData.accordions[0].accordionList} ></Accordion> */}
						</ErrorBoundary>
						<ErrorBoundary>
							<SignInForm ValidationRef={this.SignInRef} MTNRef={this.MTNRef} ZipCodeRef={this.ZipCodeRef} Data={this.props.EquipmentReturnData} KeyUpValidation={this.validateOnKeyUp.bind(this)} SignUpValidaition={this.validateForm.bind(this)} Open={this.openDialog.bind(this)}  ></SignInForm>
						</ErrorBoundary>
					</main>
					<ErrorBoundary>
					    {!isNullOrUndefined(this.props.EquipmentReturnData) && <NeedMoreSupport Data ={this.props.EquipmentReturnData}></NeedMoreSupport>}
					</ErrorBoundary>
					<ErrorBoundary>
						<EQReturnModalDialog ClassNames="custompopup" CloseCallBack={this.closeDialog.bind(this)} DialogRef={this.dialogRef} EQhandleKeyMethod={this.EQhandleKeyAction.bind(this)}>
						</EQReturnModalDialog>
					</ErrorBoundary>
					<div id="spinner" className="hide_spinner">
						<div data-page-loader className="text-center page-loader text-white active">
							<div className="loader small text-center"></div> </div>
						<center><img alt="spinner" src="/content/dam/verizon/support/consumer/supportservices/vcm-react/media/spinner.gif" /></center>
					</div>
					<ErrorBoundary>
						<Footer />
					</ErrorBoundary>
					<input type="hidden" value="UnAuth" id="loginType" />
					<ErrorBoundary>
						<SiteCatalyst PageDetails={this.props.EquipmentReturnData.pagedetails} />
					</ErrorBoundary>
				</React.Fragment>
			)
		} else if (this.state.validUser && !this.isDropOffPage) {
			return (
				<React.Fragment>
					<ErrorBoundary>
						<Header />
					</ErrorBoundary>
					<main role="main" className="main equipment eq-main padding-top-small tiny-wide">
						<ErrorBoundary>
							<BreadCrumb Content1="Support" Content2="Billing & Account" Content3="Equipment Return" />
						</ErrorBoundary>
						<ErrorBoundary>
							<div className="row">
								<AlertBanner
									AlertBannerData={this.props.AlertBanner}
									isBreadCrumb={true}
								/>
							</div>
						</ErrorBoundary>
						<ErrorBoundary>
							<EquipmentDetails SignInStaticData={this.state.signInStaticData} DynamicData={this.state.signInDynamicData} DialogOpen={this.openDialog.bind(this)} ChangeDateFormat={this.changeDateFormat.bind(this)} ClickHandler={this.printLabel.bind(this)} />
						</ErrorBoundary>
						{ /* Border */}
						<div className="tiny-padding-vert-tiny medium-padding-vert-small m_status-buttons border-bottom"></div>
						{/* Rotator Title */}
						{!isNullOrUndefined(this.state.signInDynamicData) && Object.keys(this.state.signInDynamicData).length > 0 && Object.keys(this.state.signInDynamicData.orderDetails).length > 0 &&
							<div className="row margin-vert-zero medium-vert-middle">
								<div className="column padding-vert-zero medium-p-80">
									<h1 className="h3 tiny-padding-left-medium large-padding-left-zero red_font" id="returnEquip">
										Return your equipment in four easy steps
									</h1>
								</div>
							</div>
						}
						{!isNullOrUndefined(this.state.signInDynamicData) && Object.keys(this.state.signInDynamicData).length > 0 && Object.keys(this.state.signInDynamicData.orderDetails).length > 0 &&
							<ErrorBoundary>
								<Rotator type="equipmentreturn" Data={this.state.signInStaticData.carousellist[0].equipment}></Rotator>
							</ErrorBoundary>
						}
						<ErrorBoundary>
							<NeedToKnow EQReturnData={this.state.signInStaticData} Open={this.openDialog.bind(this)} ></NeedToKnow>
						</ErrorBoundary>
					</main>
					<ErrorBoundary>
						<EQReturnModalDialog CloseCallBack={this.closeDialog.bind(this)} DialogRef={this.dialogRef} EQhandleKeyMethod={this.EQhandleKeyAction.bind(this)}>
						</EQReturnModalDialog>
					</ErrorBoundary>
					<div id="spinner" className="hide_spinner">
						<div data-page-loader className="text-center page-loader text-white active">
							<div className="loader small text-center"></div> </div>
						<center><img alt="spinner" src="/content/dam/verizon/support/consumer/supportservices/vcm-react/media/spinner.gif" /></center>
					</div>
					<ErrorBoundary>
						<Footer />
					</ErrorBoundary>
					<input type="hidden" value="Auth" id="loginType" />
					<ErrorBoundary>
						<SiteCatalyst PageDetails={this.state.signInStaticData.pagedetails} />
					</ErrorBoundary>
				</React.Fragment>
			)
		} else if (this.isDropOffPage && this.state.validUser) {
			return (
				<React.Fragment>
					<ErrorBoundary>
						<Header />
					</ErrorBoundary>
					<main role="main" className="main equipment eq-main padding-top-small tiny-wide">
					<ErrorBoundary>
							<BreadCrumb Content1="Support" Content2="Billing & Account" Content3="Equipment Return" />
						</ErrorBoundary>
						<ErrorBoundary>
							<div className="row">
								<AlertBanner
									AlertBannerData={this.props.AlertBanner}
									isBreadCrumb={true}
								/>
							</div>
						</ErrorBoundary>
						<div className="tiny-padding-vert-tiny medium-padding-vert-small padding-top-medium">
							<div className="padding-right-tiny">
								<h4 className="margin-top-zero red_font">{this.state.signInStaticData.titledesc[0].title}</h4>
								<div className="margin-bottom-tiny">
									<p className="margin-bottom-tiny">Please return the following Verizon equipment before
										<b> {this.state.signInDynamicData.equipDetails[0].ReturnDueDate} </b>
										to avoid unreturned equipment charges. Take your equipment to
										<a className="bold link-text" onClick={this.openDialog.bind(this)}
											data-track="nearest drop off locations"> nearest drop off locations.</a>
										<a className="bold link-text" href={this.getStorelocatorUrl()}
											data-track="Click here for locations"> Click here for locations</a>
									</p>
								</div>
							</div>
						</div>
						<ErrorBoundary>
							<NeedToKnow EQReturnData={this.state.signInStaticData} Open={this.openDialog.bind(this)} ></NeedToKnow>
						</ErrorBoundary>
					</main>
					<ErrorBoundary>
						<Footer />
					</ErrorBoundary>
					<ErrorBoundary>
						<EQReturnModalDialog CloseCallBack={this.closeDialog.bind(this)} DialogRef={this.dialogRef} EQhandleKeyMethod={this.EQhandleKeyAction.bind(this)}>
						</EQReturnModalDialog>
					</ErrorBoundary>

					<input type="hidden" value="Auth" id="loginType" />
					<ErrorBoundary>
						<SiteCatalyst PageDetails={this.state.signInStaticData.pagedetails} />
					</ErrorBoundary>
				</React.Fragment>
			)
		}
	}
};


// WEBPACK FOOTER //
// ./src/components/EquipmentReturnPage.js


// WEBPACK FOOTER //
// ./src/components/EquipmentReturnPage.js